import { isAddressLike } from "./cover-image";

/**
 * Address of a piece photo, and the only place that knows how to build one.
 *
 * Two key shapes, the same rule as `cover-image.ts`: an **opaque key** in the catalog bucket
 * (handoff §2 and §14), resolved against the provisional base isolated here; and the backend's
 * `GiftListProductSummaryOutput.imageUrl`, already a **full address**, which passes through
 * untouched.
 */

const PROVISIONAL_BASE = "https://taniab.vtexassets.com/arquivos/ids";

/** 1px transparent GIF: where photo `onError` lands (criterion 16). */
export const TRANSPARENT_PIXEL =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

export function resolvePieceImageUrl(imageKey: string | null): string | null {
  if (imageKey === null || imageKey.length === 0) return null;

  if (isAddressLike(imageKey)) return imageKey;

  const base = process.env.NEXT_PUBLIC_CATALOG_IMAGE_BASE_URL;

  if (base !== undefined && base.length > 0) {
    return `${base.replace(/\/$/, "")}/${imageKey}`;
  }

  return `${PROVISIONAL_BASE}/${imageKey}-800-0/x.jpg`;
}
